import { update_background } from "./changing_images.js"
import { CreateInsightContainer } from "./lit-components/insight_container.js"

var element_color = {
    'strand': ['#1fae52', '#1ea94f', '#1da44c', '#1c9f49', '#1b9a46', '#1a9543', '#199040', '#188b3d', '#17863a', '#168137', '#157c34', ], //'#1a9145',
    'solar': ['#ff7d1e', '#f6791e', '#ed751e', '#e4711e', '#db6d1e', '#d2691e', '#c9651e', '#c0611e', '#b75d1e', '#ae591e', '#a5551e', ], //'#f2721b',
    'void': ['#8463c0', '#8060ba', '#7c5db4', '#785aae', '#7457a8', '#7054a2', '#6c519c', '#684e96', '#644b90', '#60488a', '#5c4584', ], //'#6e53a0',
    'arc': ['#5792ba', '#548eb4', '#518aae', '#4e86a8', '#4b82a2', '#487e9c', '#457a96', '#427690', '#3f728a', '#3c6e84', '#396a7e', ], //'#497a9b',
    'stasis': ['#577ab6', '#5476b0', '#5172aa', '#4e6ea4', '#4b6a9e', '#486698', '#456292', '#425e8c', '#3f5a86', '#3c5680', '#39527a', ],//'#496698'
    'prismatic': ["#f16ae1", "#ee63d5", "#ea5bca", "#e753bf", "#e34cb3", "#df43a8", "#db3b9d", "#d73193", "#d32688", "#ce197d", "#ca0273"]
};

let elements = ["solar", "arc", "void", "stasis", "strand", "prismatic"];

function normalize_stat(value)
{
    if (value < 0)
        value = 0;
    if (value > 100)
        value = 100;
    return value;
}

export class Commander
{
    constructor()
    {
        this.character = null;
        this.menu_manager = null;
    }

    sendRequest(request)
    {
        switch (request.request_type)
        {
            case "check_condition":
                return this.character.check_condition(request.condition);
                break;
        }
    }

    exec_command(command)
    {
        console.log("new command:", command);

        switch (command.command_type)
        {
            case "set_effect":
                console.log('set_effect', command.effect_type)

                if (command.effect_type == "subclass")
                {
                    this.character.set_subclass(command.effect_id);
                }
                else if (command.effect_type == "class")
                {
                    this.character.set_class(command.effect_id);

                    this.exec_command(
                        {
                            command_type: "set_effect",
                            effect_id: this.character.get_effect(this.character.class).subclasses.get(this.character.element),
                            effect_type:  "subclass",
                            slot_index: null,
                            armor_slot : null
                        }
                    );
                }

                break;
            case "set_stat":
                this.character.set_stat(command.stat_id, command.stat_value);
                break;
            case "set_effect_stack":
                this.character.set_effect_stack(command.effect_id, command.stack_value);
                break;
            case "set_effect_duration":
                this.character.set_effect_duration(command.effect_id, command.duration_value);
                break;
            case "set_ability_energy":
                this.character.set_ability_energy(command.energy_value, command.ability_type);
                break;
            case "set_activity":
                this.character.set_activity_type(command.activity_id);
                break;
        }
    }

    update(update)
    {
        console.log("new update:", update);

        switch (update.update_type)
        {
            case "update_insight":
                update_insight(update.effect, this.character);
                break;
            case "update_menu_selections":
                let subclass = this.character.get_effect(update.subclass_id);
                this.menu_manager.updateSlotSelection("super_ability", 0, subclass.supers);
                this.menu_manager.updateSlotSelection("grenade_ability", 0, subclass.grenades);
                this.menu_manager.updateSlotSelection("melee_ability", 0, subclass.melees);
                this.menu_manager.updateSlotSelection("class_ability", 0, subclass.class_abilities);
                this.menu_manager.updateSlotSelection("aspect", 0, subclass.aspects);
                this.menu_manager.updateSlotSelection("aspect", 1, subclass.aspects);

                for (let i = 0; i < 6; i++)
                {
                    this.menu_manager.updateSlotSelection("fragment", i, subclass.fragments);
                }

                break;
            case "update_background":
                update_background(update.subclass_id);
                break;
            case "update_stat_color":
                redraw_stat(update.stat_name, update.subclass_element);
                break;
            case "update_stats_colors":
                // updates
                for (let stat_name of ['mobility', 'resilience', 'recovery', 'discipline', 'intellect', 'strength'])
                {
                    redraw_stat(stat_name, update.subclass_element, this.character);
                }
                break;
            case "update_exotic_armor_selection":
                this.menu_manager.updateSlotSelection("exotic_armor", 0, this.character.get_effect(this.character.class).exotic_armor);
                break;
            case "update_minor_stats":
                for (let major_stat of Object.entries(this.character.dependent_stats))
                {
                    switch (major_stat)
                    {
                        case 'mobility':
                            document.getElementById('Walk Speed').textContent = (this.character.dependent_stats[major_stat].walk_speed + 'm/s');
                            document.getElementById('Strafe Speed').textContent = this.character.dependent_stats[major_stat].strafe_speed + 'm/s';
                            document.getElementById('Crouch Speed').textContent = this.character.dependent_stats[major_stat].crouch_speed + 'm/s';
                            break;
                        case 'resilience':
                            document.getElementById('Shield Amount').textContent = this.character.dependent_stats[major_stat].shield_amount;
                            document.getElementById('Health Amount').textContent = this.character.dependent_stats[major_stat].health_amount;
                            document.getElementById('Flinch Resistance').textContent = this.character.dependent_stats[major_stat].flinch_resistance + '%';
                            document.getElementById('Resist Against Combatants').textContent = this.character.dependent_stats[major_stat].resist_against_combatants + '%';
                            break;
                        case 'recovery':
                            document.getElementById('Health Regen Delay').textContent = this.character.dependent_stats[major_stat].health_regen_delay + 's';
                            document.getElementById('Shield Regen Delay').textContent = this.character.dependent_stats[major_stat].shield_regen_delay + 's';
                            document.getElementById('Health Regen Time').textContent = this.character.dependent_stats[major_stat].health_regen_time + 's';
                            document.getElementById('Shield Regen Time').textContent = this.character.dependent_stats[major_stat].shield_regen_time + 's';
                            document.getElementById('Health+Shield Regen Time').textContent = this.character.dependent_stats[major_stat].health_shield_regen_time + 's';
                            document.getElementById('Total Regen Time').textContent = this.character.dependent_stats[major_stat].total_regen_time + 's';
                            break;
                        case 'discipline':
                            document.getElementById('Grenade Regeneration Rate').textContent = this.character.dependent_stats[major_stat].grenade_regeneration_rate;
                            break;
                        case 'intellect':
                            document.getElementById('Super Regeneration Rate').textContent = this.character.dependent_stats[major_stat].super_regeneration_rate;
                            break;
                        case 'strength':
                            document.getElementById('Melee Regeneration Rate').textContent = this.character.dependent_stats[major_stat].melee_regeneration_rate;
                            break;
                    }
                }
                break;
            case "save_class":
                localStorage.setItem('class_id', update.class_id);
                break;
            case "save_element":
                localStorage.setItem('element_id', update.element);
                break;
            case "update_effect_template":
                update_effect_template(update.effect_id, this.character);
                break;
            case "update_displayed_cooldown":
                document.getElementById(`insight_${update.ability_id}`).updateDisplayCooldown(update.string_value);
                break;
            case "update_activity_select_list":
                update_activity_select_list(update.sandbox);
                break;
            case "update_subclass_buttons":
                for (let element of elements)
                {
                    document.getElementById(`${element}_select_button`).setAttribute("data-subclass-id", update.element_to_subclass.get(element));
                }
                break;
        }
    }
}

function update_armor_charge_count(character)
{
    let armor_charges = character.get_armor_charge_capacity();
    for (let i = 0; i < armor_charges; i++)
    {
        document.getElementById(`armor_charge_button_${i}`).style.display = 'block';
    }
    for (let i = armor_charges; i < 7; i++)
    {
        document.getElementById(`armor_charge_button_${i}`).style.display = 'none';
    }
}

function update_effect_template(effect_id, character)
{
    document.getElementById(`insight_${effect_id}`).updateEffectTemplateText(character.get_template(effect_id));
    //document.getElementById(`template_${effect_id}`).innerHTML = character.get_template(effect_id);
}

function redraw_stat(stat_name, element, character)
{
    if (element == null)
        return;

    let raw_stat = character.get_stat(stat_name); // can be less than 0
    let stat_bonus = character.getUserStatBonus(stat_name); // > 0
    let res = character.getStaWithBonus(stat_name);
    let dynamicBonus = 0;

    if (character.dummy_stats != null) // todo: remove cycle
    {
        for (let simpleValue of character.dummy_stats.data.pvp)
        {
            if (simpleValue.get_relates_to() == stat_name)
                dynamicBonus = simpleValue.get_value();
        }
    }

    let raw_sum = raw_stat + stat_bonus + dynamicBonus;
    let colored = normalize_stat(raw_sum);

//    for testing purposes to see uncolored tiles
//    for (let i = 0; i <= 100; i += 10)
//    {
//        document.getElementById(stat_name + '_' + i).style.backgroundColor = "black";
//    }

    if (raw_stat >= 0)
    {
        for (let i = 0; i <= Math.min(raw_stat + 10, 100); i += 10)
        {
            document.getElementById(stat_name + '_' + i).style.backgroundColor = element_color[element][i / 10];
        }
    }

    if (raw_stat + stat_bonus >= 0)
    {
        for (let i = Math.max(0, raw_stat + 10); i <= Math.min(raw_stat + stat_bonus + 10, 100); i += 10)
        {
            document.getElementById(stat_name + '_' + i).style.backgroundColor = "green";
        }
    }

    if (raw_stat + stat_bonus + dynamicBonus >= 0)
    {
        for (let i = Math.max(0, raw_stat + stat_bonus + 10); i <= Math.min(raw_stat + stat_bonus + dynamicBonus + 10, 100); i += 10)
        {
            document.getElementById(stat_name + '_' + i).style.backgroundColor = "#93add2";
        }
    }

    if (colored == 0)
    {
        document.getElementById(stat_name + '_' + 0).style.backgroundColor = element_color[element][0];
    }

    for (let i = colored + 10; i <= 100; i += 10)
    {
        document.getElementById(stat_name + '_' + i).style.backgroundColor = "grey";
    }
}

function update_insight(effect, character)
{
    console.log('update_insights', effect, effect.visibility)

    if (effect.visibility == 'hidden')
    {
        return;
    }

    if (effect.counter == 1)
    {
        let place = 'right_column';

        switch (effect.type)
        {
            case "perk":
            {
                switch (effect.subtype)
                {
                    case 'aspect':
                        place = 'aspect_section';
                        break;
                    case 'fragment':
                        place = 'fragment_section';
                        break;
                    case 'exotic_armor_intrinsic':
                        place = 'exotic_armor_section';
                        break;
                    case 'exotic_weapon_intrinsic':
                        place = 'exotic_weapon_section';
                        break;
                    case "blue_armor_mod":
                        place = 'active_effects_section';
                        break;
                }
                break;
            }
            case 'class_ability':
                place = 'class_ability_section';
                place = 'class_ability_section';
                break;
            case 'melee_ability':
                place = 'melee_ability_section';
                break;
            case 'super_ability':
                place = 'super_ability_section';
                break;
            case 'grenade_ability':
                place = 'grenade_ability_section';
                break;
            case 'entity':
                place = 'rest_section';
                break;
            case 'buff':
                place = 'active_effects_section';
                break;
            case 'debuff':
                place = 'active_effects_section';
                break;
            case 'armor_mod':
                place = 'armor_mods_section';
                break;
        }

        console.log('place:', place, effect.id, effect.type)

        let container = CreateInsightContainer(effect, character.sandbox);
        document.getElementById(place).appendChild(container);

        if (effect.type == "buff")
        {
            if (effect.get_default_duration(character.sandbox) != null)
            {
                effect.set_duration(effect.get_default_duration(character.sandbox));
                container.updateDisplayDuration(effect.get_default_duration(character.sandbox));
            }
        }

    }
    else if (effect.counter > 1)
    {
        //console.log('update_insights() -> no need to add insight ' + effect.id);
    }
    else
    {
        document.getElementById(`insight_${effect.id}`).remove();
    }
}

function update_activity_select_list(sandbox)
{
    let a = document.getElementById("activity_select");

    let activity_select = a;

    for (let i = 0; i < activity_select.options.length; i++)
    {
        //console.log('activity_id', activity_select.options[i]);
        if (activity_select.options[i].getAttribute('data-sandbox') != sandbox)
        {
            activity_select.options[i].setAttribute('hidden', 'true');
        }
        else
        {
            activity_select.options[i].removeAttribute('hidden');
        }
    }

    for (var i = 0; i < activity_select.options.length; i++)
    {
        if (!activity_select.options[i].hidden)
        {
            activity_select.selectedIndex = i;
            var event = new Event('change');
            activity_select.dispatchEvent(event);
            break;
        }
    }
}
